import { Card, DefinitionRow } from '@/components/card'
import { PageHeader } from '@/components/page-header'
import { PageShell } from '@/components/page-shell'
import { useHealth } from '@/features/health/use-health'

function formatUptime(seconds: number) {
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = seconds % 60
  return h > 0 ? `${h}h ${m}m` : m > 0 ? `${m}m ${s}s` : `${s}s`
}

export function SystemPage() {
  const { data, isPending, isError, error, dataUpdatedAt } = useHealth()

  return (
    <PageShell>
      <PageHeader
        title="System"
        description="Live-Statusabfrage gegen GET /api/v1/health — prüft zugleich die Datenbankverbindung."
      />

      <Card
        title="Status"
        footer={
          dataUpdatedAt
            ? `Zuletzt aktualisiert ${new Date(dataUpdatedAt).toLocaleTimeString('de-DE')}`
            : undefined
        }
      >
        {isPending && <p className="text-muted text-sm">Wird geladen …</p>}

        {isError && (
          <p className="text-danger text-sm">
            API nicht erreichbar: {error instanceof Error ? error.message : 'Unbekannter Fehler'}
            <span className="text-muted mt-2 block text-xs">
              Läuft der Backend-Prozess? <code className="font-mono">pnpm dev:api</code>
            </span>
          </p>
        )}

        {data && (
          <dl>
            <DefinitionRow label="Status" value={data.status} />
            <DefinitionRow label="Version" value={data.version} />
            <DefinitionRow label="Laufzeit" value={formatUptime(data.uptime)} />
            <DefinitionRow
              label="Datenbank"
              value={data.database.connected ? 'verbunden' : 'getrennt'}
            />
            <DefinitionRow label="Migrationen" value={data.database.appliedMigrations} />
            <DefinitionRow label="Letzte Migration" value={data.database.latestMigration ?? '—'} />
          </dl>
        )}
      </Card>
    </PageShell>
  )
}
